import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import LinkingAttemptForm from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptForm';
import LinkingEventsMetaTable from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingEventsMetaTable';
import SuccessRateDetails
  from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate/MainPanel/SuccessRateDetails/SuccessRateDetails';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});
const LinkingAttemptsDetails = ({
  resource,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchData() {
      if (resource) {
        const [accountData] = await resource.relationship(fr.relationships.linkingEvents.name).link('related').get();
        setData(accountData);
      }
    }

    fetchData().finally(() => {
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <LoadingIndicator />;
  }
  if (!data) {
    return null;
  }
  return (
    <React.Fragment>
      <LinkingAttemptForm resource={resource} />
      <LinkingEventsMetaTable resource={resource} />
    </React.Fragment>
  );
};
LinkingAttemptsDetails.propTypes = {
  resource: PropTypes.object.isRequired,
};
const MainPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();

  function handleExpanded(resource) {
    return (
      <SuccessRateDetails
        resource={resource}
      />
    );
  }

  return (
    <MetaTable
      onExpanded={handleExpanded}
      className={classNames(className, classes.root)}
      collection={pageContentCollection}
      isPageView
      columns={[
        { name: 'name' },
        { name: 'activeAggregator' },
        { name: 'finicitySuccessRate' },
        { name: 'plaidSuccessRate' },
        { name: 'yodleeSuccessRate' },
        { name: 'totalLinks' },
      ]}
      RowProps={{
        metaOverrideSet,
      }}
    />
  );
};

MainPanel.defaultProps = {
  className: '',
};

MainPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPanel);
